import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'
import React from 'react'

import { ImageGallery } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGallery'
import { useImageGalleryContext } from '@f-fertighaus/applications/Next/components/common/ImageGallery/ImageGalleryContext'
import { t } from '@f-fertighaus/applications/Next/public/locales/de'
import { useHouseDetail } from '@f-fertighaus/applications/Next/utils/context/HouseDetail'
import { webtrack } from '@f-fertighaus/applications/Next/utils/webtrack'
import { FloorPlansCtaBanner } from '@f-fertighaus/applications/Next/views/houseDetailPage/HouseImageGallery/FloorPlansCtaBanner'

export const FloorPlansTab = () => {
  const {
    state: { floor_plans }
  } = useHouseDetail()
  const { dispatch } = useImageGalleryContext()

  if (!floor_plans) {
    return null
  }

  const focusViewImageSources = floor_plans.map(imageSource => ({
    src: imageSource['max-1600x1200.watermarked'],
    alt: imageSource.alt_text
  }))

  return (
    <Box sx={{ marginTop: 1 }}>
      <ImageGallery.ImagesContainer>
        {floor_plans.map((imageSource, index) => {
          const handleContentClick = () => {
            dispatch({
              type: 'openFocusView',
              imageSources: focusViewImageSources,
              displayImgIndex: index
            })
            webtrack({
              category: 'CTA-button',
              action: 'click',
              label: 'expand-image',
              location: 'image-gallery',
              values: [{ type: 'text', value: '(ICON)' }]
            })
          }

          const handleExpandIconClick = (
            event: React.MouseEvent<HTMLButtonElement>
          ) => {
            event.stopPropagation()
            dispatch({
              type: 'openFocusView',
              imageSources: focusViewImageSources,
              displayImgIndex: index
            })
            webtrack({
              category: 'image',
              action: 'click',
              label: 'expand-image',
              location: 'image-gallery',
              values: [{ type: 'text', value: '(ICON)' }]
            })
          }

          return (
            <GalleryImageWrapper
              key={imageSource['max-1600x1200.watermarked']}
              sx={{ marginBottom: '8px' }}>
              <ImageGallery.ImageBox
                onContentClick={handleContentClick}
                onExpandIconClick={handleExpandIconClick}>
                <ImageGallery.Image
                  srcSet={`${imageSource['fill-320x240']} 450w,
                     ${imageSource['width-640x480']} 600w,
                     ${imageSource['width-1280x960']} 1000w,
                     ${imageSource['max-1600x1200.watermarked']} 1600w,
                     ${imageSource.original} 2048w
                     `}
                  sizes='100vw'
                  src={`${imageSource.original}`}
                  alt={imageSource.alt_text}
                />
              </ImageGallery.ImageBox>
              <Typography
                variant='body2'
                fontWeight='fontWeightBold'
                sx={{ textAlign: 'center', marginTop: 1 }}>
                {t('houseDetailPage.image_gallery.floor_plans.image_label', {
                  number: index + 1
                })}
              </Typography>
            </GalleryImageWrapper>
          )
        })}
      </ImageGallery.ImagesContainer>
      <FloorPlansCtaBanner />
    </Box>
  )
}

export const GalleryImageWrapper = styled(Box)`
  &:nth-of-type(even) > div {
    border-radius: var(--border-radius-card-medium)
      var(--border-radius-card-large) var(--border-radius-card-large)
      var(--border-radius-card-medium);

    img {
      border-radius: var(--border-radius-card-medium)
        var(--border-radius-card-large) var(--border-radius-card-large)
        var(--border-radius-card-medium);
    }
  }
  &:nth-of-type(odd) > div {
    border-radius: var(--border-radius-card-large)
      var(--border-radius-card-medium) var(--border-radius-card-medium)
      var(--border-radius-card-large);

    img {
      border-radius: var(--border-radius-card-large)
        var(--border-radius-card-medium) var(--border-radius-card-medium)
        var(--border-radius-card-large);
    }
  }
  &:last-of-type:nth-of-type(odd) > div {
    border-radius: var(--border-radius-card-large);

    img {
      border-radius: var(--border-radius-card-large);
    }
  }
`
